import React from 'react'
import RulesCmp from './Rules'
import RulesApi from '../../api/Rules'
import useFetchList from '../../elements/Hooks/useFetchList'

const api = new RulesApi()
export default function RulesCont() {
  const {fetch, fetching, list} = useFetchList(api.list)
  return <RulesCmp {...{fetch, fetching, list}} />
}
